import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import objectAssign from 'object-assign';

import { clone } from '../reducers/helper';
import { hasPermissionMR } from 'businessLogic/checkExistOrVerifyPermissions';
import { updateFetchingMR } from 'actions/meetingRoom';
import MRManageUsersContent from '../components/pages/meeting-room/manage-users/content';
import NotFoundPage from './NotFoundPage.js';

// refactoring - will uncomment after the merge with meeting room module branch
// function MeetingRoomManageUsersPage(props) {
//   let selectedMeetingRoom = useSelector((state) => state.meetingRoomReducer.selectedMeetingRoom);
//   const selectMeetingRoomId = useSelector((state)=>state.meetingRoomReducer.selectedMeetingRoomId);
//   let usersIcanManageInThisMR = [];
//   const [availableRoles,setAvailableRoles] = useState();

//   const allMeetingRooms = useSelector((state) => state.meetingRoomReducer.meetingRooms);

//   console.log('selectedMeetingRoom', selectedMeetingRoom);

//   useEffect(() => {
//     selectedMeetingRoom = allMeetingRooms.find((mr) => {
//       return mr.id == props.match.params.id;
//     });
//   },[]);

//   console.log('selectedMeetingRoom---UPDATED', selectedMeetingRoom);

//   const dispatch = useDispatch();

//     if (selectedMeetingRoom && !!selectMeetingRoomId) {
//       console.log('inside 1st if');
//     setAvailableRoles(useSelector((state)=>state.meetingRoomReducer.selectedMeetingRoom.availableRoles));
//     console.log('Available roles inside 1st if', availableRoles);
//     if (useSelector((state)=>state.usersReducer.usersIcanManage) && useSelector((state)=>state.usersReducer.usersIcanManage.length) > 0) {
//       usersIcanManageInThisMR = useSelector((state)=>state.usersReducer.usersIcanManage);
//     }
//   }
//   let networkId = props.match.params.id;
//   // Necessary code to check permission
//   let fetchingMeetingRoom = useSelector((state)=>state.meetingRoomReducer.fetchingMeetingRoom);
//   const state = useSelector((state)=>state);
//   let canAccess = fetchingMeetingRoom === false ? hasPermissionMR(state, networkId, 'EDIT') : true;
//   let meetingRoom = objectAssign({}, state.meetingRoomReducer.cleanMeetingRoomFormMeetingRoom, selectedMeetingRoom);

//   //     selectedMeetingRoom: meetingRoom,
//    selectedMeetingRoom = meetingRoom;
// //     searchTerm: state.meetingRoomReducer.currentMeetingRoomNameFilter,
// //     searchTerm: state.meetingRoomReducer.currentMeetingRoomMemberFilter || '',
// const searchTerm = useSelector((state)=>state.meetingRoomReducer.currentMeetingRoomMemberFilter || '');
// //     timezone: state.usersReducer.userProfile.timezoneOffsetNow,
// const timezone = useSelector((state)=>state.usersReducer.userProfile.timezoneOffsetNow);
// //     usersIcanManage: usersIcanManageInThisMR,
// const usersIcanManage = usersIcanManageInThisMR;
// //     userId: state.usersReducer.userProfile.id,
// const userId = useSelector((state)=>state.usersReducer.userProfile.id);
// //     hasMeetingRooms: state.usersReducer.userProfile.hasMeetingRooms,
// const hasMeetingRooms = useSelector((state)=>state.usersReducer.userProfile.hasMeetingRooms);
// //     canAccess: canAccess,
// console.log('canAccess',canAccess);

// //     showMeetingRoomAddUsersModal: state.modalReducer.showMeetingRoomAddUsersModal,
// const showMeetingRoomAddUsersModal = useSelector((state)=>state.modalReducer.showMeetingRoomAddUsersModal);
// //     showMeetingRoomManageUsersRolesModal: state.modalReducer.showMeetingRoomManageUsersRolesModal,
// const showMeetingRoomManageUsersRolesModal = useSelector((state)=>state.modalReducer.showMeetingRoomManageUsersRolesModal);
// //     availableRoles: availableRoles,
// console.log('availableRoles',availableRoles);

// //     selectedMRUsersEmail: state.meetingRoomReducer.selectedMRUsersEmail,
// const selectedMRUsersEmail = useSelector((state)=>state.meetingRoomReducer.selectedMRUsersEmail);
// //     previousPage: state.navigationBarReducer.previousPage,
// const previousPage = useSelector((state)=>state.navigationBarReducer.previousPage);

//   if (
//     userId > 0 &&
//     (props.redirectToPageNotFound || !hasMeetingRooms || canAccess == false)
//   )
//     return <NotFoundPage dispatch={dispatch} />;

//   return (
//     <div>
//       MeetingRoomManageUsersPage
//       <MRManageUsersContent
//         id={parseInt(props.match.params.id)}
//         selectedMeetingRoom={selectedMeetingRoom}
//         searchTerm={searchTerm}
//         usersIcanManage={usersIcanManage}
//         timezone={timezone}
//         userId={userId}
//         availableRoles={availableRoles}
//         showMeetingRoomAddUsersModal={showMeetingRoomAddUsersModal}
//         showMeetingRoomManageUsersRolesModal={showMeetingRoomManageUsersRolesModal}
//         selectedMRUsersEmail={selectedMRUsersEmail}
//         previousPage={previousPage}
//         dispatch={dispatch}
//       />
//     </div>
//   );
// }

// function mapStateToProps(state, props) {
//   let selectedMeetingRoom = state.meetingRoomReducer.selectedMeetingRoom;
//   let usersIcanManageInThisMR = [];
//   let availableRoles = [];

//   // Update selected meeting room
//   selectedMeetingRoom = state.meetingRoomReducer.meetingRooms.find((mr) => {
//     return mr.id == props.match.params.id;
//   });

//   if (selectedMeetingRoom && !!state.meetingRoomReducer.selectedMeetingRoomId) {
//     availableRoles = selectedMeetingRoom.availableRoles || state.meetingRoomReducer.selectedMeetingRoom.availableRoles;
//     if (state.usersReducer.usersIcanManage && state.usersReducer.usersIcanManage.length > 0) {
//       usersIcanManageInThisMR = state.usersReducer.usersIcanManage;
//     }
//   }

//   let networkId = props.match.params.id;
//   // Necessary code to check permission
//   let fetchingMeetingRoom = state.meetingRoomReducer.fetchingMeetingRoom;
//   let canAccess = fetchingMeetingRoom === false ? hasPermissionMR(state, networkId, 'EDIT') : true;

//   let meetingRoom = objectAssign({}, state.meetingRoomReducer.cleanMeetingRoomFormMeetingRoom, selectedMeetingRoom);

//   return {
//     selectedMeetingRoom: meetingRoom,
//     searchTerm: state.meetingRoomReducer.currentMeetingRoomNameFilter,
//     timezone: state.usersReducer.userProfile.timezoneOffsetNow,
//     usersIcanManage: usersIcanManageInThisMR,
//     userId: state.usersReducer.userProfile.id,
//     searchTerm: state.meetingRoomReducer.currentMeetingRoomMemberFilter || '',
//     hasMeetingRooms: state.usersReducer.userProfile.hasMeetingRooms,
//     canAccess: canAccess,
//     showMeetingRoomAddUsersModal: state.modalReducer.showMeetingRoomAddUsersModal,
//     showMeetingRoomManageUsersRolesModal: state.modalReducer.showMeetingRoomManageUsersRolesModal,
//     availableRoles: availableRoles,
//     selectedMRUsersEmail: state.meetingRoomReducer.selectedMRUsersEmail,
//     previousPage: state.navigationBarReducer.previousPage,
//   };
// }

// export default MeetingRoomManageUsersPage;

@connect(mapStateToProps)
export default class MeetingRoomManageUsersPage extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount() {
    //Set getting meeting room = {} to force fetching meeting room info & permission first
    this.props.dispatch(updateFetchingMR({}));
  }

  render() {
    // permissions check
    if (
      this.props.userId > 0 &&
      (this.props.redirectToPageNotFound || !this.props.hasMeetingRooms || this.props.canAccess == false)
    )
      return <NotFoundPage dispatch={this.props.dispatch} />;

    return (
      <MRManageUsersContent
        id={parseInt(this.props.match.params.id)}
        selectedMeetingRoom={this.props.selectedMeetingRoom}
        searchTerm={this.props.searchTerm}
        usersIcanManage={this.props.usersIcanManage}
        timezone={this.props.timezone}
        userId={this.props.userId}
        availableRoles={this.props.availableRoles}
        showMeetingRoomAddUsersModal={this.props.showMeetingRoomAddUsersModal}
        showMeetingRoomManageUsersRolesModal={this.props.showMeetingRoomManageUsersRolesModal}
        selectedMRUsersEmail={this.props.selectedMRUsersEmail}
        previousPage={this.props.previousPage}
        dispatch={this.props.dispatch}
      />
    );
  }
}

function mapStateToProps(state, props) {
  let selectedMeetingRoom = state.meetingRoomReducer.selectedMeetingRoom;
  let usersIcanManageInThisMR = [];
  let availableRoles = [];

  // Update selected meeting room
  selectedMeetingRoom = state.meetingRoomReducer.meetingRooms.find((mr) => {
    return mr.id == props.match.params.id;
  });

  if (selectedMeetingRoom && !!state.meetingRoomReducer.selectedMeetingRoomId) {
    availableRoles = selectedMeetingRoom.availableRoles || state.meetingRoomReducer.selectedMeetingRoom.availableRoles;
    if (state.usersReducer.usersIcanManage && state.usersReducer.usersIcanManage.length > 0) {
      usersIcanManageInThisMR = state.usersReducer.usersIcanManage;
    }
  }

  let networkId = props.match.params.id;
  // Necessary code to check permission
  let fetchingMeetingRoom = state.meetingRoomReducer.fetchingMeetingRoom;
  let canAccess = fetchingMeetingRoom === false ? hasPermissionMR(state, networkId, 'EDIT') : true;

  let meetingRoom = objectAssign({}, state.meetingRoomReducer.cleanMeetingRoomFormMeetingRoom, selectedMeetingRoom);

  return {
    selectedMeetingRoom: meetingRoom,
    searchTerm: state.meetingRoomReducer.currentMeetingRoomNameFilter,
    timezone: state.usersReducer.userProfile.timezoneOffsetNow,
    usersIcanManage: usersIcanManageInThisMR,
    userId: state.usersReducer.userProfile.id,
    searchTerm: state.meetingRoomReducer.currentMeetingRoomMemberFilter || '',
    hasMeetingRooms: state.usersReducer.userProfile.hasMeetingRooms,
    canAccess: canAccess,
    showMeetingRoomAddUsersModal: state.modalReducer.showMeetingRoomAddUsersModal,
    showMeetingRoomManageUsersRolesModal: state.modalReducer.showMeetingRoomManageUsersRolesModal,
    availableRoles: availableRoles,
    selectedMRUsersEmail: state.meetingRoomReducer.selectedMRUsersEmail,
    previousPage: state.navigationBarReducer.previousPage,
  };
}
